
import { getAutoTransferOverseasCustomerIdsApi } from '@/apis/inShipping'

export default {
  namespaced: true,
  state: {
    // 是否是crossmall店铺
    isCrossMall: false
  },
  getters: {
    isCrossMall (state:any) {
      return state.isCrossMall
    }
  },
  mutations: {
    SET_CROSS_MALL: (
      state:any,
      isWhite: boolean
    ): void => {
      state.isCrossMall = isWhite
    }
  },
  actions: {
    async getCrossMallShop (store: any) {
      const { commit, rootState } = store
      if (!rootState.route.curShop) {
        commit('SET_CROSS_MALL', false)
        return
      }
      const shopInfo = rootState.route?.user?.customerShopList?.find((v:any) => v.customerShopId === rootState.route.curShop)
      console.log('rootStaterootState', shopInfo)
      const res = await getAutoTransferOverseasCustomerIdsApi({})
      commit('SET_CROSS_MALL', res.data.includes(shopInfo?.customerId) && shopInfo?.customerShopPlatform !== 4)
    }
  }
}
